import React from 'react';
import { Route, Routes } from 'react-router';
import { usePageTitle } from '../../config';
import { NestedApiLocalizationProvider } from 'src/provider/LocalizationProviderConnector';
import IngramPrograms from './IngramPrograms/IngramPrograms';
import IngramProgramDetails from './IngramProgramDetails/IngramProgramDetails';

export function IngramProgramsRoute() {
  const { updatePageTitle } = usePageTitle();

  updatePageTitle('Ingram Programs - GDE');

  return (
    <NestedApiLocalizationProvider
      preloadResources={['IngramPrograms', 'Common', 'Pagination']}
    >
      <Routes>
        <Route element={<IngramPrograms />} path="" />
        <Route element={<IngramProgramDetails />} path="/:id" />
      </Routes>
    </NestedApiLocalizationProvider>
  );
}
